import React from "react";
import Seo from "../components/Seo";
import Layout from "../layouts/sample";

import {Intro} from "../components/use/Intro";
import {TabsSection} from "../components/use/TabsSection";
import {TryRootstock} from "../components/use/TryRootstock";
import {Deploy} from "../components/use/Deploy";
import {Ecosystem} from "../components/develop/Ecosystem";
import {StayInTouch} from "../components/use/StayInTouch";
import {Subscribe} from "../components/global/Subscribe";

import {graphql} from "gatsby";

const UsePage = (props) => {
  const acf = props.data.page.template.usePageACF || {};

  const translations = props?.data?.page?.translations || {}

  const stats = props?.data?.page?.template?.statsACF.numbers || [];

  return (
    <Layout translations={translations}>
      <Intro data={acf.intro} stats={stats} numbers={acf.explore}/>
      <TabsSection tabsData={acf.items}/>
      <TryRootstock data={acf.system}/>
      <Deploy data={acf.bitcoin}/>
      <Ecosystem color={'green'} data={acf.ecosystem}/>
      <StayInTouch data={acf.resources} />
      <Subscribe/>
    </Layout>
  );
};

export default UsePage;
export const pageQuery = graphql`
  query ($lng: String!, $id: Int!) {
    locales: allLocale(
      filter: { language: { eq: $lng } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    page : wpPage(language: {slug: {eq: $lng}}, databaseId: { eq: $id }) {
      translations {
        slug
      }
      seo {
        metaDesc
        opengraphDescription
        opengraphTitle
        title
      }
      template {
        ... on WpTemplate_Use {
          templateName
          statsACF {
            numbers {
              label
              title
              value
              source
              image {
                localFile {
                  publicURL
                }
                publicUrl
                width
                height
            }
            }
          }
          usePageACF {
            bitcoin {
              columnLeft
              columnRight
              fieldGroupName
              items {
                color
                button {
                  title
                  url
                  target
                }
                text
                title
              }
              number
              subtitle
              suptext1
              suptext2
              titlePart2
              titlePart1
              titlePart3
            }
            ecosystem {
              link {
                target
                title
                url
              }
              number
              text
              subtitle
              title
            }
            intro {
              number
              suptext1
              suptext2
              text
              titlePart1
              titlePart2
              titlePart3
              titlePart4
              titlePart5
            }
            items {
              text
              title
              link {
                title
                url
                target
              }
              icon {
                height
                publicUrl
                width
                localFile {
                  publicURL
                }
              }
              image {
                localFile {
                  publicURL
                }
                publicUrl
                width
                height
              }
            }
            resources {
              items {
                color
                label
                button {
                  target
                  title
                  url
                }
                text
              }
              subtitle
              title
            }
            system {
              columnLeft
              link {
                title
                url
                target
              }
              title
            }
          }
        }
      }
    }
  }
`;

export const Head = (props) => {
  const seo = props.data.page?.seo || {}
  return <Seo title={seo?.title} description={seo?.metaDesc} />;
}
